export const platformNameByTypeMap = {
  ccm: 'CourseFactory.Workplace',
  scorm: 'SCORM',
  canvas: 'Canvas',
  moodle: 'Moodle',
  iracademy: 'Reezonly',
};
